// import React, { useEffect, useMemo, useState } from "react";
// import { toast } from "react-toastify";
// import {
//   listPricing,
//   createPricing,
//   updatePricing,
//   deletePricing,
// } from "./pricingApi";
// import { Plus, Pencil, Trash2 } from "lucide-react";

// // 0=Sun ... 6=Sat to match common backends
// const DOW = [
//   { v: 0, l: "Sun" },
//   { v: 1, l: "Mon" },
//   { v: 2, l: "Tue" },
//   { v: 3, l: "Wed" },
//   { v: 4, l: "Thu" },
//   { v: 5, l: "Fri" },
//   { v: 6, l: "Sat" },
// ];

// const emptyRule = {
//   price: "",
//   appExclusivePrice: "",
//   unit: "hour",
//   startTime: "06:00",
//   endTime: "10:00",
//   days: [1, 2, 3, 4, 5],
// };

// const RuleForm = ({ initial = emptyRule, onCancel, onSubmit, currency = "INR" }) => {
//   const [f, setF] = useState(initial || emptyRule);
//   useEffect(() => {
//     setF(initial || emptyRule);
//   }, [initial]);

//   const toggleDay = (d) => {
//     setF((p) => {
//       const s = new Set(p.days || []);
//       s.has(d) ? s.delete(d) : s.add(d);
//       return { ...p, days: Array.from(s).sort((a, b) => a - b) };
//     });
//   };

//   const submit = (e) => {
//     e.preventDefault();
//     const eNum = parseFloat(f.price);
//     if (Number.isNaN(eNum) || eNum < 0)
//       return toast.error("Enter a valid price.");
//     if (!f.startTime || !f.endTime) return toast.error("Pick a time range.");
//     if ((f.days || []).length === 0)
//       return toast.error("Pick at least one day.");

//     // normalize to HH:mm (some browsers may add seconds)
//     const toHHMM = (s) => {
//       if (!s) return "";
//       const [hh, mm] = String(s).split(":");
//       return `${String(hh || "00").padStart(2, "0")}:${String(mm || "00").padStart(2, "0")}`;
//     };
//     const appExclusiveNum =
//       f.appExclusivePrice === "" || f.appExclusivePrice == null
//         ? null
//         : parseFloat(f.appExclusivePrice);

//     if (
//       appExclusiveNum !== null &&
//       (Number.isNaN(appExclusiveNum) || appExclusiveNum < 0)
//     ) {
//       return toast.error("Enter a valid app exclusive price.");
//     }

//     if (appExclusiveNum !== null && appExclusiveNum >= eNum) {
//       return toast.error("App exclusive price must be less than price.");
//     }

//     const payload = {
//       price: eNum,
//       appExclusivePrice: appExclusiveNum,
//       unit: f.unit || "hour",
//       startTime: toHHMM(f.startTime),
//       endTime: toHHMM(f.endTime),
//       days: f.days,
//     };

//     onSubmit?.(payload);
//   };

//   return (
//     <form className="sa-form" onSubmit={submit} noValidate>
//       <div className="sa-grid">
//         <div className="sa-field">
//           <label>Price</label>
//           <input
//             type="number"
//             min="0"
//             step="0.01"
//             value={f.price}
//             onChange={(e) => setF((p) => ({ ...p, price: e.target.value }))}
//             placeholder="1200"
//           />
//         </div>
//         <div className="sa-field">
//           <label>App Exclusive Price (Optional)</label>
//           <input
//             type="number"
//             min="0"
//             step="0.01"
//             value={f.appExclusivePrice ?? ""}
//             onChange={(e) =>
//               setF((p) => ({ ...p, appExclusivePrice: e.target.value }))
//             }
//             placeholder="800"
//           />
//         </div>

//         <div className="sa-field">
//           <label>Currency</label>
//           <input type="text" value={currency} readOnly disabled />

//         </div>

//         <div className="sa-field">
//           <label>Unit</label>
//           <select
//             value={f.unit}
//             onChange={(e) => setF((p) => ({ ...p, unit: e.target.value }))}
//           >
//             <option value="hour">Hour</option>
//             <option value="slot">Slot</option>
//           </select>
//         </div>

//         <div className="sa-field">
//           <label>Start Time</label>
//           <input
//             type="time"
//             step={60}
//             value={f.startTime}
//             onChange={(e) => setF((p) => ({ ...p, startTime: e.target.value }))}
//           />
//         </div>

//         <div className="sa-field">
//           <label>End Time</label>
//           <input
//             type="time"
//             step={60}
//             value={f.endTime}
//             onChange={(e) => setF((p) => ({ ...p, endTime: e.target.value }))}
//           />
//         </div>

//         <div className="sa-field sa-col-span-2">
//           <label>Days</label>
//           <div className="sa-checks">
//             {DOW.map((d) => (
//               <label key={d.v} className="sa-check">
//                 <input
//                   type="checkbox"
//                   checked={(f.days || []).includes(d.v)}
//                   onChange={() => toggleDay(d.v)}
//                 />
//                 <span>{d.l}</span>
//               </label>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="sa-modal-actions">
//         <button type="submit" className="sa-btn">
//           Save
//         </button>
//         <button type="button" className="sa-btn-outline" onClick={onCancel}>
//           Cancel
//         </button>
//       </div>

//     </form>
//   );
// };

// const fmtDays = (days = []) => {
//   if (!days.length) return "—";
//   if (days.length === 7) return "Everyday";
//   const map = new Map(DOW.map((d) => [d.v, d.l]));
//   return days.map((d) => map.get(d) || d).join(", ");
// };

// const PricingModal = ({ open, onClose, ground }) => {
//   const [rules, setRules] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [creating, setCreating] = useState(false);
//   const [editing, setEditing] = useState(null); // rule obj
//   const [busyId, setBusyId] = useState(null);
//   const [deleting, setDeleting] = useState(null); // rule being deleted

//   const load = async () => {
//     if (!ground?._id && !ground?.id) return;
//     setLoading(true);
//     try {
//       const data = await listPricing(ground._id || ground.id);
//       setRules(Array.isArray(data) ? data : []);
//     } catch {
//       toast.error("Failed to load pricing rules");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (open) load(); /* eslint-disable-next-line */
//   }, [open, ground?._id, ground?.id]);

//   const addRule = async (payload) => {
//     try {
//       await createPricing(ground._id || ground.id, payload);
//       toast.success("Rule added");
//       setCreating(false);
//       load();
//     } catch (e) {
//       toast.error(e?.response?.data?.message || "Create failed");
//     }
//   };

//   const saveRule = async (payload) => {
//     try {
//       const id = editing?._id || editing?.id;
//       await updatePricing(id, payload);
//       toast.success("Rule updated");
//       setEditing(null);
//       load();
//     } catch (e) {
//       toast.error(e?.response?.data?.message || "Update failed");
//     }
//   };

//   const delRule = async (r) => {
//     try {
//       const id = r?._id || r?.id;
//       setBusyId(id);
//       await deletePricing(id);
//       toast.success("Rule deleted");
//       load();
//     } catch (e) {
//       toast.error(e?.response?.data?.message || "Delete failed");
//     } finally {
//       setBusyId(null);
//     }
//   };

//   if (!open) return null;

//   return (
//     <div className="sa-modal">
//       <div className="sa-modal-backdrop" onClick={onClose} />
//       <div className="sa-modal-card" style={{ maxWidth: 900 }}>
//         <div className="sa-modal-hd">
//           <h3>Pricing — {ground?.name || "Ground"}</h3>
//           <button className="sa-x" onClick={onClose}>
//             ✕
//           </button>
//         </div>

//         {loading ? (
//           <div className="sa-placeholder" style={{ height: 120 }}>
//             Loading…
//           </div>
//         ) : (
//           <>
//             <div className="sa-head-row" style={{ marginTop: 8 }}>
//               <div />
//               <button className="sa-btn" onClick={() => setCreating(true)}>
//                 <Plus className="lucide" /> Add Rule
//               </button>
//             </div>

//             {rules.length === 0 ? (
//               <div className="sa-empty">
//                 <div>No pricing rules yet.</div>
//                 <button className="sa-btn" onClick={() => setCreating(true)}>
//                   Add first rule
//                 </button>
//               </div>
//             ) : (
//               <div className="sa-table-wrap sa-table-wrap--responsive">
//                 <table className="sa-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: 60 }}>S.N.</th>
//                       <th>Days</th> <th>Time Range</th>
//                       <th>Price</th>
//                       <th style={{ textAlign: "right", width: 110 }}>
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {rules.map((r, i) => (
//                       <tr key={r._id || r.id}>
//                         <td>{i + 1}</td>
//                         <td>{fmtDays(r.days)}</td>
//                         <td>
//                           {r.startTime}–{r.endTime}
//                         </td>
//                         <td>
//                           <div>
//                             {r.price} {r.currency || "INR"}/{r.unit || "hour"}
//                           </div>

//                           {r.appExclusivePrice !== null && r.appExclusivePrice !== undefined && (
//                             <div style={{ fontSize: "12px", color: "#0f766e", marginTop: 4 }}>
//                               App Exclusive: {r.appExclusivePrice} {r.currency || "INR"}/{r.unit || "hour"}
//                             </div>
//                           )}
//                         </td>
//                         <td className="sa-actions-cell">
//                           <div className="sa-actions">
//                             <button
//                               className="sa-icon-link"
//                               onClick={() =>
//                                 setEditing({
//                                   ...r,
//                                   price: r.price,
//                                   appExclusivePrice:
//                                     r.appExclusivePrice !== null && r.appExclusivePrice !== undefined
//                                       ? r.appExclusivePrice
//                                       : "",
//                                   currency: r.currency || "INR",
//                                   unit: r.unit || "hour",
//                                   startTime: r.startTime || "06:00",
//                                   endTime: r.endTime || "10:00",
//                                   days: Array.isArray(r.days) ? r.days : [],
//                                 })
//                               }
//                               title="Edit rule"
//                             >
//                               <Pencil className="lucide" />
//                             </button>
//                             <button
//                               className="sa-icon-link danger"
//                               onClick={() => setDeleting(r)}
//                               disabled={busyId === (r._id || r.id)}
//                               title="Delete rule"
//                             >
//                               <Trash2 className="lucide" />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </>
//         )}

//         {/* CREATE FORM */}
//         {creating && (
//           <div className="sa-modal" style={{ zIndex: 1002 }}>
//             <div
//               className="sa-modal-backdrop"
//               onClick={() => setCreating(false)}
//             />
//             <div className="sa-modal-card" style={{ maxWidth: 680 }}>
//               <div className="sa-modal-hd">
//                 <h3>New Pricing Rule</h3>
//                 <button className="sa-x" onClick={() => setCreating(false)}>
//                   ✕
//                 </button>
//               </div>
//               <RuleForm
//                 initial={emptyRule}
//                 currency={ground?.currency || "INR"}
//                 onCancel={() => setCreating(false)}
//                 onSubmit={addRule}
//               />

//             </div>
//           </div>
//         )}

//         {/* EDIT FORM */}
//         {editing && (
//           <div className="sa-modal" style={{ zIndex: 1002 }}>
//             <div
//               className="sa-modal-backdrop"
//               onClick={() => setEditing(null)}
//             />
//             <div className="sa-modal-card" style={{ maxWidth: 680 }}>
//               <div className="sa-modal-hd">
//                 <h3>Edit Pricing Rule</h3>
//                 <button className="sa-x" onClick={() => setEditing(null)}>
//                   ✕
//                 </button>
//               </div>
//               <RuleForm
//                 initial={editing}
//                 currency={ground?.currency || editing?.currency || "INR"}
//                 onCancel={() => setEditing(null)}
//                 onSubmit={saveRule}
//               />

//             </div>
//           </div>
//         )}
//         {/* DELETE CONFIRM MODAL */}
//         {deleting && (
//           <div className="sa-modal" style={{ zIndex: 1002 }}>
//             <div
//               className="sa-modal-backdrop"
//               onClick={() => setDeleting(null)}
//             />
//             <div className="sa-modal-card" style={{ maxWidth: 560 }}>
//               <div className="sa-modal-hd">
//                 <h3>Delete Pricing Rule</h3>
//                 <button className="sa-x" onClick={() => setDeleting(null)}>
//                   ✕
//                 </button>
//               </div>

//               <div style={{ padding: "12px 6px 0" }}>
//                 <div className="sa-warn">
//                   This action cannot be undone. The rule will be permanently
//                   removed.
//                 </div>

//                 <div className="sa-del-preview">
//                   <div className="sa-del-meta">
//                     <div className="sa-del-title">
//                       {fmtDays(deleting?.days)} — {deleting?.startTime} to{" "}
//                       {deleting?.endTime}
//                     </div>
//                     <div className="sa-del-sub">
//                       <span className="sa-gray">
//                         ID: {deleting?._id || deleting?.id || "—"}
//                       </span>
//                       <span className="sa-dot">•</span>
//                       <span className="sa-gray">
//                         {deleting?.price} {deleting?.currency}/{deleting?.unit}
//                       </span>

//                       {deleting?.appExclusivePrice !== null &&
//                         deleting?.appExclusivePrice !== undefined && (
//                           <>
//                             <span className="sa-dot">•</span>
//                             <span className="sa-gray">
//                               App Exclusive: {deleting?.appExclusivePrice} {deleting?.currency}/{deleting?.unit}
//                             </span>
//                           </>
//                         )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="sa-modal-actions">
//                 <button
//                   type="button"
//                   className="sa-btn-danger"
//                   onClick={async () => {
//                     try {
//                       await delRule(deleting); // reuse existing delete
//                       setDeleting(null);
//                     } catch (e) {
//                       toast.error(e?.response?.data?.message || "Delete failed");
//                     }
//                   }}
//                   disabled={busyId === (deleting?._id || deleting?.id)}
//                 >
//                   {busyId === (deleting?._id || deleting?.id) ? "Deleting…" : "Delete"}
//                 </button>

//                 <button
//                   type="button"
//                   className="sa-btn-outline"
//                   onClick={() => setDeleting(null)}
//                   disabled={busyId === (deleting?._id || deleting?.id)}
//                 >
//                   Cancel
//                 </button>
//               </div>

//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PricingModal;

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  listPricing,
  createPricing,
  updatePricing,
  deletePricing,
} from "./pricingApi";
import { Plus, Pencil, Trash2 } from "lucide-react";

import ReusableModal from "../../../components/common/ReusableModal";
import FormButton from "../../../components/form/FormButton";
import FormField from "../../../components/form/FormField";
import FormInput from "../../../components/form/FormInput";
import FormSelect from "../../../components/form/FormSelect";

import "./venue-ground.css";

const DOW = [
  { v: 0, l: "Sun" },
  { v: 1, l: "Mon" },
  { v: 2, l: "Tue" },
  { v: 3, l: "Wed" },
  { v: 4, l: "Thu" },
  { v: 5, l: "Fri" },
  { v: 6, l: "Sat" },
];

const emptyRule = {
  price: "",
  appExclusivePrice: "",
  unit: "hour",
  startTime: "06:00",
  endTime: "10:00",
  days: [1, 2, 3, 4, 5],
};

const toHHMM = (value) => {
  if (!value) return "";
  const [hh, mm] = String(value).split(":");
  return `${String(hh || "00").padStart(2, "0")}:${String(mm || "00").padStart(
    2,
    "0"
  )}`;
};

const fmtDays = (days = []) => {
  if (!days.length) return "—";
  if (days.length === 7) return "Everyday";

  const map = new Map(DOW.map((day) => [day.v, day.l]));
  return days.map((day) => map.get(day) || day).join(", ");
};

const normaliseInitialRule = (rule) => ({
  ...emptyRule,
  ...(rule || {}),
  price:
    rule?.price !== undefined && rule?.price !== null ? String(rule.price) : "",
  appExclusivePrice:
    rule?.appExclusivePrice !== undefined && rule?.appExclusivePrice !== null
      ? String(rule.appExclusivePrice)
      : "",
  unit: rule?.unit || "hour",
  startTime: rule?.startTime || "06:00",
  endTime: rule?.endTime || "10:00",
  days: Array.isArray(rule?.days) ? rule.days : emptyRule.days,
});

const RuleFormModal = ({
  open,
  title,
  initial = emptyRule,
  currency = "INR",
  submitting = false,
  onCancel,
  onSubmit,
}) => {
  const [form, setForm] = useState(normaliseInitialRule(initial));
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setForm(normaliseInitialRule(initial));
    setErrors({});
  }, [initial, open]);

  const set = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const clearError = (key) => {
    setErrors((prev) => {
      if (!prev[key]) return prev;

      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const toggleDay = (day) => {
    setForm((prev) => {
      const selected = new Set(prev.days || []);

      if (selected.has(day)) {
        selected.delete(day);
      } else {
        selected.add(day);
      }

      return {
        ...prev,
        days: Array.from(selected).sort((a, b) => a - b),
      };
    });

    clearError("days");
  };

  const validate = () => {
    const nextErrors = {};

    const price = parseFloat(form.price);

    if (Number.isNaN(price) || price < 0) {
      nextErrors.price = "Enter a valid price";
    }

    if (!form.startTime || !form.endTime) {
      nextErrors.time = "Pick a time range";
    }

    if (!Array.isArray(form.days) || form.days.length === 0) {
      nextErrors.days = "Pick at least one day";
    }

    const appExclusivePrice =
      form.appExclusivePrice === "" || form.appExclusivePrice == null
        ? null
        : parseFloat(form.appExclusivePrice);

    if (
      appExclusivePrice !== null &&
      (Number.isNaN(appExclusivePrice) || appExclusivePrice < 0)
    ) {
      nextErrors.appExclusivePrice = "Enter a valid app exclusive price";
    }

    if (
      appExclusivePrice !== null &&
      !Number.isNaN(price) &&
      appExclusivePrice >= price
    ) {
      nextErrors.appExclusivePrice =
        "App exclusive price must be less than price";
    }

    setErrors(nextErrors);

    const firstError = Object.values(nextErrors).find(Boolean);
    if (firstError) toast.error(firstError);

    return nextErrors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (submitting) return;

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) return;

    const price = parseFloat(form.price);

    const appExclusivePrice =
      form.appExclusivePrice === "" || form.appExclusivePrice == null
        ? null
        : parseFloat(form.appExclusivePrice);

    const payload = {
      price,
      appExclusivePrice,
      unit: form.unit || "hour",
      startTime: toHHMM(form.startTime),
      endTime: toHHMM(form.endTime),
      days: Array.isArray(form.days) ? form.days : [],
    };

    await onSubmit?.(payload);
  };

  return (
    <ReusableModal
      open={open}
      title={title}
      width="680px"
      closeOnBackdrop={false}
      onClose={() => {
        if (!submitting) onCancel?.();
      }}
    >
      <form className="pricing-rule-form" onSubmit={handleSubmit} noValidate>
        <div className="pricing-rule-grid">
          <FormField label={`Price (${currency})`} error={errors.price}>
            <FormInput
              type="number"
              min="0"
              step="0.01"
              value={form.price}
              onChange={(event) => {
                set("price", event.target.value);
                clearError("price");
              }}
              placeholder="1200"
            />
          </FormField>

          <FormField
            label={`App Exclusive Price (${currency})`}
            error={errors.appExclusivePrice}
            hint="Optional. Must be lower than the normal price."
          >
            <FormInput
              type="number"
              min="0"
              step="0.01"
              value={form.appExclusivePrice ?? ""}
              onChange={(event) => {
                set("appExclusivePrice", event.target.value);
                clearError("appExclusivePrice");
              }}
              placeholder="800"
            />
          </FormField>

          <FormField label="Currency">
            <FormInput type="text" value={currency} readOnly disabled />
          </FormField>

          <FormField label="Unit">
            <FormSelect
              value={form.unit}
              onChange={(event) => set("unit", event.target.value)}
            >
              <option value="hour">Hour</option>
              <option value="slot">Slot</option>
            </FormSelect>
          </FormField>

          <FormField label="Start Time" error={errors.time}>
            <FormInput
              type="time"
              step={60}
              value={form.startTime}
              onChange={(event) => {
                set("startTime", event.target.value);
                clearError("time");
              }}
            />
          </FormField>

          <FormField label="End Time" error={errors.time}>
            <FormInput
              type="time"
              step={60}
              value={form.endTime}
              onChange={(event) => {
                set("endTime", event.target.value);
                clearError("time");
              }}
            />
          </FormField>

          <FormField label="Days" error={errors.days} className="pricing-span-2">
            <div className="pricing-days">
              {DOW.map((day) => {
                const active = (form.days || []).includes(day.v);

                return (
                  <button
                    key={day.v}
                    type="button"
                    className={`pricing-day ${active ? "is-active" : ""}`}
                    onClick={() => toggleDay(day.v)}
                    aria-pressed={active}
                  >
                    {day.l}
                  </button>
                );
              })}
            </div>
          </FormField>
        </div>

        <div className="pricing-actions">
          <FormButton type="submit" variant="primary" disabled={submitting}>
            {submitting ? "Saving..." : "Save"}
          </FormButton>

          <FormButton
            type="button"
            variant="secondary"
            onClick={onCancel}
            disabled={submitting}
          >
            Cancel
          </FormButton>
        </div>
      </form>
    </ReusableModal>
  );
};

const DeletePricingRuleModal = ({
  open,
  rule,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  return (
    <ReusableModal
      open={open}
      title="Delete Pricing Rule"
      width="560px"
      className="pricing-delete-rule-modal"
      closeOnBackdrop={false}
      onClose={() => {
        if (!loading) onCancel?.();
      }}
    >
      <div className="pricing-delete">
        <div className="sa-warn">
          This action cannot be undone. The rule will be permanently removed.
        </div>

        <div className="sa-del-preview">
          <div className="sa-del-meta">
            <div className="sa-del-title">
              {fmtDays(rule?.days)} — {rule?.startTime} to {rule?.endTime}
            </div>

            <div className="sa-del-sub">
              <span className="sa-gray">ID: {rule?._id || rule?.id || "—"}</span>
              <span className="sa-dot">•</span>
              <span className="sa-gray">
                {rule?.price} {rule?.currency || "INR"}/{rule?.unit || "hour"}
              </span>

              {rule?.appExclusivePrice !== null &&
                rule?.appExclusivePrice !== undefined && (
                  <>
                    <span className="sa-dot">•</span>
                    <span className="sa-gray">
                      App Exclusive: {rule?.appExclusivePrice}{" "}
                      {rule?.currency || "INR"}/{rule?.unit || "hour"}
                    </span>
                  </>
                )}
            </div>
          </div>
        </div>

        <div className="pricing-actions">
          <FormButton
            type="button"
            variant="danger"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </FormButton>

          <FormButton
            type="button"
            variant="secondary"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </ReusableModal>
  );
};

const PricingModal = ({ open, onClose, ground }) => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);

  const [creating, setCreating] = useState(false);
  const [editing, setEditing] = useState(null);
  const [deleting, setDeleting] = useState(null);

  const [submittingRule, setSubmittingRule] = useState(false);
  const [busyId, setBusyId] = useState(null);

  const groundId = ground?._id || ground?.id;
  const currency = ground?.currency || "INR";

  const load = async () => {
    if (!groundId) return;

    setLoading(true);

    try {
      const data = await listPricing(groundId);
      setRules(Array.isArray(data) ? data : []);
    } catch {
      toast.error("Failed to load pricing rules");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) return;

    setCreating(false);
    setEditing(null);
    setDeleting(null);
    setBusyId(null);
    load();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, groundId]);

  const handleClose = () => {
    if (submittingRule || busyId) return;
    onClose?.();
  };

  const addRule = async (payload) => {
    try {
      setSubmittingRule(true);

      await createPricing(groundId, payload);

      toast.success("Rule added");
      setCreating(false);

      await load();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Create failed");
      throw error;
    } finally {
      setSubmittingRule(false);
    }
  };

  const saveRule = async (payload) => {
    const id = editing?._id || editing?.id;

    if (!id) {
      toast.error("Missing pricing rule id");
      return;
    }

    try {
      setSubmittingRule(true);

      await updatePricing(id, payload);

      toast.success("Rule updated");
      setEditing(null);

      await load();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Update failed");
      throw error;
    } finally {
      setSubmittingRule(false);
    }
  };

  const confirmDeleteRule = async () => {
    const id = deleting?._id || deleting?.id;

    if (!id) {
      toast.error("Missing pricing rule id");
      return;
    }

    try {
      setBusyId(id);

      await deletePricing(id);

      toast.success("Rule deleted");
      setDeleting(null);

      await load();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Delete failed");
    } finally {
      setBusyId(null);
    }
  };

  if (!open) return null;

  return (
    <>
      <ReusableModal
        open={open}
        title={`Pricing — ${ground?.name || "Ground"}`}
        width="900px"
        className="pricing-list-modal"
        closeOnBackdrop={false}
        onClose={handleClose}
      >
        <div className="pricing-modal">
          {loading ? (
            <div className="sa-placeholder" style={{ height: 120 }}>
              Loading…
            </div>
          ) : (
            <>
              <div className="pricing-head">
                <div>
                  <div className="pricing-title">Pricing Rules</div>
                  <div className="pricing-subtitle">
                    Manage day-wise and time-wise pricing for this ground.
                  </div>
                </div>

                <FormButton
                  type="button"
                  variant="primary"
                  className="pricing-new-btn"
                  onClick={() => setCreating(true)}
                >
                  <Plus className="lucide" /> Add Rule
                </FormButton>
              </div>

              {rules.length === 0 ? (
                <div className="sa-empty">
                  <div>No pricing rules yet.</div>

                  <FormButton
                    type="button"
                    variant="primary"
                    onClick={() => setCreating(true)}
                  >
                    Add first rule
                  </FormButton>
                </div>
              ) : (
                <div className="sa-table-wrap pricing-table-wrap">
                  <table className="sa-table pricing-table">
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>S.N.</th>
                        <th>Days</th>
                        <th>Time Range</th>
                        <th>Price</th>
                        <th style={{ textAlign: "right", width: 110 }}>
                          Actions
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {rules.map((rule, index) => {
                        const id = rule._id || rule.id;

                        return (
                          <tr key={id}>
                            <td>{index + 1}</td>
                            <td>{fmtDays(rule.days)}</td>
                            <td>
                              {rule.startTime}–{rule.endTime}
                            </td>
                            <td>
                              <div>
                                {rule.price} {rule.currency || currency}/
                                {rule.unit || "hour"}
                              </div>

                              {rule.appExclusivePrice !== null &&
                                rule.appExclusivePrice !== undefined && (
                                  <div className="pricing-exclusive">
                                    App Exclusive: {rule.appExclusivePrice}{" "}
                                    {rule.currency || currency}/
                                    {rule.unit || "hour"}
                                  </div>
                                )}
                            </td>

                            <td className="sa-actions-cell">
                              <div className="sa-actions">
                                <button
                                  type="button"
                                  className="sa-icon-link"
                                  onClick={() =>
                                    setEditing({
                                      ...rule,
                                      price: rule.price,
                                      appExclusivePrice:
                                        rule.appExclusivePrice !== null &&
                                          rule.appExclusivePrice !== undefined
                                          ? rule.appExclusivePrice
                                          : "",
                                      currency: rule.currency || currency,
                                      unit: rule.unit || "hour",
                                      startTime: rule.startTime || "06:00",
                                      endTime: rule.endTime || "10:00",
                                      days: Array.isArray(rule.days)
                                        ? rule.days
                                        : [],
                                    })
                                  }
                                  disabled={busyId === id}
                                  title="Edit rule"
                                  aria-label="Edit rule"
                                >
                                  <Pencil className="lucide" />
                                </button>

                                <button
                                  type="button"
                                  className="sa-icon-link danger"
                                  onClick={() => setDeleting(rule)}
                                  disabled={busyId === id}
                                  title="Delete rule"
                                  aria-label="Delete rule"
                                >
                                  <Trash2 className="lucide" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>
      </ReusableModal>

      <RuleFormModal
        open={creating}
        title="New Pricing Rule"
        initial={emptyRule}
        currency={currency}
        submitting={submittingRule}
        onCancel={() => {
          if (!submittingRule) setCreating(false);
        }}
        onSubmit={addRule}
      />

      <RuleFormModal
        open={!!editing}
        title="Edit Pricing Rule"
        initial={editing || emptyRule}
        currency={editing?.currency || currency}
        submitting={submittingRule}
        onCancel={() => {
          if (!submittingRule) setEditing(null);
        }}
        onSubmit={saveRule}
      />

      <DeletePricingRuleModal
        open={!!deleting}
        rule={deleting}
        loading={busyId === (deleting?._id || deleting?.id)}
        onCancel={() => {
          if (busyId !== (deleting?._id || deleting?.id)) {
            setDeleting(null);
          }
        }}
        onConfirm={confirmDeleteRule}
      />

      <style>{`
        .pricing-modal,
        .pricing-rule-form,
        .pricing-rule-grid,
        .pricing-rule-grid > *,
        .pricing-span-2,
        .pricing-actions {
          box-sizing: border-box;
          max-width: 100%;
          min-width: 0;
        }

        .pricing-modal {
          width: 100%;
          overflow-x: hidden;
        }

        .pricing-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
          margin-bottom: 16px;
        }

        .pricing-title {
          font-size: 16px;
          font-weight: 800;
          color: #111827;
        }

        .pricing-subtitle {
          margin-top: 3px;
          font-size: 13px;
          color: #64748b;
          line-height: 1.4;
        }

        .pricing-new-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .pricing-table-wrap {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }

        .pricing-table {
          min-width: 640px;
        }

        .pricing-exclusive {
          margin-top: 4px;
          color: #0f766e;
          font-size: 12px;
          line-height: 1.35;
          font-weight: 600;
        }

        .pricing-rule-form {
          display: flex;
          flex-direction: column;
          gap: 18px;
          width: 100%;
          overflow-x: hidden;
        }

        .pricing-rule-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 18px;
          align-items: start;
          width: 100%;
          overflow-x: hidden;
        }

        .pricing-span-2 {
          grid-column: 1 / -1;
        }

        .pricing-days {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          width: 100%;
        }

        .pricing-day {
          min-height: 40px;
          border: 1px solid #d9e2ec;
          border-radius: 999px;
          padding: 0 14px;
          background: #ffffff;
          color: #111827;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
        }

        .pricing-day.is-active {
          border-color: var(--brand);
          background: rgba(51, 164, 68, 0.1);
          color: #14532d;
          box-shadow: 0 0 0 3px rgba(51, 164, 68, 0.12);
        }

        .pricing-actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          padding-top: 8px;
          border-top: 1px solid #e8edf3;
        }

        .pricing-delete {
          display: flex;
          flex-direction: column;
          gap: 18px;
        }

        @media (max-width: 820px) {
          .pricing-head {
            flex-direction: column;
            align-items: stretch;
          }

          .pricing-new-btn {
            width: 100%;
            justify-content: center;
          }

          .pricing-rule-grid {
            grid-template-columns: minmax(0, 1fr);
            gap: 17px;
          }

          .pricing-span-2 {
            grid-column: auto;
          }

          .pricing-days {
            gap: 8px;
          }

          .pricing-day {
            flex: 1 1 calc(33.333% - 8px);
            padding: 0 10px;
          }

          .pricing-actions {
            flex-direction: column;
          }

          .pricing-actions .fs-btn {
            width: 100%;
          }
        }
          @media (max-width: 820px) {
  .pricing-list-modal,
  .pricing-delete-rule-modal {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}

        @media (max-width: 390px) {
          .pricing-day {
            flex-basis: calc(50% - 8px);
          }

          .pricing-rule-grid {
            gap: 15px;
          }
        }
      `}</style>
    </>
  );
};

export default PricingModal;